import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback } from 'react';
import ConfirmBox from '../../confirm-box/ConfirmBox';
import { useFormContext } from '../FormContext';
import * as styles from './Confirm.style';
const Confirm = _ref => {
  let {
    visible,
    onConfirm,
    ...rest
  } = _ref;
  const context = useFormContext();
  const onInternalConfirm = useCallback(() => {
    onConfirm(context.values);
  }, [context, onConfirm]);
  return visible ? /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.base
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.box
  }, /*#__PURE__*/React.createElement(ConfirmBox, _extends({}, rest, {
    onConfirm: onInternalConfirm
  })))) : null;
};
export default Confirm;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Confirm___StyledDiv",
  componentId: "sc-1ebmw7m-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Confirm___StyledDiv2",
  componentId: "sc-1ebmw7m-1"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=Confirm.js.map